export default "__VITE_PUBLIC_ASSET__89a79e72__"